import React from 'react'

import lang from '@/lang'
import { ConfirmModal } from '@/modules/base/components/modal'
import { TrialModalProps } from '@/modules/base/components/modal/trial-modal/trial-modal-props'

const TrialModalDefault = (props: TrialModalProps) => {
  const { open, productType, dataQsId, onClose, onStartTrial } = props

  return (
    <ConfirmModal
      open={open}
      dataQsId={dataQsId}
      title={lang.myAccount.subscriptionUpgrade.trialModal.title(productType)}
      description={lang.myAccount.subscriptionUpgrade.trialModal.description(productType)}
      confirmButtonLabel={lang.myAccount.subscriptionUpgrade.trialModal.confirmButtonLabel}
      onConfirm={onStartTrial}
      onAbort={onClose} />
  )
}

export default TrialModalDefault
